import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/taskListTemplateItem/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/taskListTemplateItem/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/taskListTemplateItem/FETCH_FAILURE'

const CREATE_REQUEST = 'realhub/taskListTemplateItem/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/taskListTemplateItem/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/taskListTemplateItem/CREATE_FAILURE'

const UPDATE_REQUEST = 'realhub/taskListTemplateItem/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/taskListTemplateItem/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/taskListTemplateItem/UPDATE_FAILURE'

const DELETE_REQUEST = 'realhub/taskListTemplateItem/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/taskListTemplateItem/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/taskListTemplateItem/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadTaskListTemplateItems(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/agency/task_list_template_items.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TASK_LIST_TEMPLATE_ITEM_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function createTaskListTemplateItem(taskListTemplateItem, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      task_list_template_item: taskListTemplateItem,
    }),
  }

  return (dispatch) => {
    dispatch(createRequest())

    const { task_list_template_id } = taskListTemplateItem
    const promise = api(`/agency/task_list_templates/${task_list_template_id}/items.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TASK_LIST_TEMPLATE_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function updateTaskListTemplateItem(taskListTemplateItem, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      task_list_template_item: taskListTemplateItem,
    }),
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const { id, task_list_template_id } = taskListTemplateItem
    const promise = api(`/agency/task_list_templates/${task_list_template_id}/items/${id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TASK_LIST_TEMPLATE_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function updateTemplateItemSortOrder(taskListTemplateSection, templateItemIds, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      sort_order: templateItemIds,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const { task_list_template_id } = taskListTemplateSection
    const promise = api(
      `/agency/task_list_templates/${task_list_template_id}/items/update_sort_order.json`,
      options,
      config,
    )
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TASK_LIST_TEMPLATE_ITEM_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
        return { success: false, result: errors }
      })

    return promise
  }
}

export function deleteTaskListTemplateItem(taskListTemplateItem){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const { id, task_list_template_id } = taskListTemplateItem
    const promise = api(`/agency/task_list_templates/${task_list_template_id}/items/${id}.json`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        const normalizedJson = normalize(json, Schemas.TASK_LIST_TEMPLATE_ITEM)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))

        return { success: false, result: errors }
      })
    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
